
import Vue from 'vue';
import api from '@/api/api';


const CNAVSHOW = 'CNAVSHOW' ;//头部分类
const GETCLASSIFYPRO = 'GETCLASSIFYPRO';//分类页商品列表
const GETNAVLIST = 'GETNAVLIST';//分类list列表


const NAVSHOWTOGGLE = 'NAVSHOWTOGGLE';
const GETPROLIST = 'GETPROLIST'; 
const GETCATEGORYID = 'GETCATEGORYID';

export default {
	state: {
		navBtnShow: false,//是否显示头部导航按钮

		classifyProList: [],//分类页商品列表
		classifyPage: 0,
		classifyPageSize: 10,
		classifyTotalPage: 0,
		
		navList: {},//分类信息列表

	},
	actions: {
		classifyNavShow( {commit} ) {
			commit(CNAVSHOW);
		},
		getCategory( { commit,state }){
			commit('GETCATEGORYID');
		},
		getClassifyProList({dispatch, commit,state},data){ //分类页列表
			// state.classifyPage = 0;
			var parma = {
				categoryId: data.categoryId, //二级分类Id
				fristCategoryId: data.fristCategoryId,//一级分类Id
				pageNo: state.classifyPage+1,
				pageSize: state.classifyPageSize
		    }
			console.log(parma);
			return new Promise(function(resolve ,reject){
				//api.post('/getProList',parma,function(res){
				api.post('api/appclient/v2/product/list',parma,function(res){
					console.log(res.body);
					commit(GETCLASSIFYPRO,{
						data: res.body.data
					});
					resolve(res);
				})
			})
		},
		getNavList({commit},data){
		 	api.get('api/appclient/v2/product/category',{},function(res){
			 	commit( GETNAVLIST ,{
					data: res.body.data
				})
			})
		},
	},
	mutations:{
		[CNAVSHOW](state){
			state.navBtnShow = !state.navBtnShow;
		},
		[GETCLASSIFYPRO](state,options){
			state.classifyProList = options.data.pageNo <= 1 ? options.data.itemList : state.classifyProList.concat(options.data.itemList);
			state.classifyPage = options.data.pageNo;
			state.classifyTotalPage = options.data.totalPage;
		},
		[GETNAVLIST](state,options){
			state.navList = options.data;
		},
		[GETCATEGORYID](state,options){
			state.classifyPage = 0;
			state.classifyProList = [];
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/store/homeState.js